import { render, staticRenderFns } from "./IncomeDetailModule.vue?vue&type=template&id=020f6c16&scoped=true"
import script from "./IncomeDetailModule.vue?vue&type=script&lang=js"
export * from "./IncomeDetailModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "020f6c16",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('020f6c16')) {
      api.createRecord('020f6c16', component.options)
    } else {
      api.reload('020f6c16', component.options)
    }
    module.hot.accept("./IncomeDetailModule.vue?vue&type=template&id=020f6c16&scoped=true", function () {
      api.rerender('020f6c16', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/appBasicSetup/components/IncomeDetailModule.vue"
export default component.exports